import { logger } from '../logger/index.ts';

export const removalLogger = logger<string>('removal');
